<div 
    class="kn-toast-container" 
    [ngClass]="{
        'compressed': compressedMasthead
    }"
    id="{{componentId}}">
</div>
